import { Injectable } from '@angular/core'

import { Store } from './store'
import { ApiService } from './api.service'
import { Card } from '../models/card'

@Injectable()
export class CardService extends Store<Card> {

  constructor(private api: ApiService) {
    super(new Card({ }))
  }

  public getCard(cardId: string): void {
    this.api.findCurrent<Card>('cards/' + cardId, this.subject, Card)
  }
}
